module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_13",
    attrs: {
      "id": "calibre_pb_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("And how shall you rise beyond your days and")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("nights unless you break the chains which you at the")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("dawn of your understanding have fastened around")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("your noon hour?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("In truth that which you call freedom is the strongest")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("of these chains, though its links glitter in the sun")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("and dazzle your eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_16"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("from ")]), _c('span', {
    staticClass: "text_8"
  }, [_vm._v("The Prophet")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v(" by Kahlil Gibran")])]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_c('br', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608d0260","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 75
// module chunks = 0